<template>
  <div class="agreement">
    <span v-html="agree_text"></span>

    <template v-if="hasVideo">{{ $tr('videoInterview.checkVideo.videoAgree') }}</template>
  </div>
</template>

<script>
import { isDomainRu } from '@/_helpers/utils.js';
import { mapState, mapGetters } from 'vuex';
import axios from 'axios';

export default {
  name: 'AgreeTextDefault',

  props: {
    hasVideo: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      companyAgreementPublicList: []
    };
  },

  computed: {
    ...mapState('locale', { locale: 'value' }),

    ...mapState('landing', { token: 'token', landing: 'item' }),

    ...mapGetters('locale', ['is_japan_locale']),

    country() {
      return this.landing && this.landing.country ? this.landing.country.code : null;
    },

    company_agreements() {
      let res = [];

      if (this.companyAgreementPublicList.length > 0) {
        res = this.companyAgreementPublicList.map(item => {
          let name = null;

          if (this.locale === 'ru') {
            name = item.names.filter(v => v.language.code === 'ru');
          } else {
            name = item.names.filter(v => v.language.code === 'en');
          }

          if (item.url) {
            return `<a href="${item.url}" target="_blank">${name[0].name}</a>`;
          } else {
            return false;
          }
        });
      }

      if (res.length > 0) {
        res = res.join(', ') + '.';
      }

      return res;
    },

    agree_text() {
      let res = this.$tr('vacancy.openRegistration.personalAgree', {
        agreement_link: this.agreement_link,
        user_agreement_link: this.user_agreement_link,
        privacy_link: this.privacy_link,
        terms_link: this.terms_link,
        cookies_link: this.cookies_link
      });

      if (this.company_agreements.length > 0) {
        res = `${res}, ${this.company_agreements}`;
      } else {
        res = `${res}.`;
      }

      return res;
    },

    lang() {
      const countryIso = this.country.toLowerCase();

      if (this.country && (countryIso === 'ja' || countryIso === 'jp')) {
        return 'ja';
      }
      if (this.is_japan_locale) {
        return 'ja';
      }

      if (this.country) {
        if (countryIso === 'ru') {
          return 'ru';
        } else if (countryIso === 'ja' || countryIso === 'jp') {
          return 'ja';
        } else {
          return 'ai';
        }
      }

      if (isDomainRu) {
        return 'ru';
      } else {
        return 'ai';
      }
    },

    agreement_link() {
      return `https://vcv.${this.current_domain}/pages/agreement/`;
    },

    user_agreement_link() {
      return `https://vcv.${this.current_domain}/pages/user-agreement/`;
    },

    privacy_link() {
      switch (this.lang) {
        case 'ru':
          return 'https://vcv.ru/pages/privacy-policy';
        case 'en':
          return 'https://vcv.ai/pages/privacy-policy';
        case 'ja':
          return 'https://vcv.co.jp/privacy_policy/';
        default:
          return 'https://vcv.ai/pages/privacy-policy';
      }
    },

    cookies_link() {
      switch (this.lang) {
        case 'en':
          return 'https://vcv.ai/pages/cookies-terms';
        case 'ru':
          return 'https://vcv.ru/pages/cookies-terms-ru';
        case 'ja':
          return 'https://vcv.ai/pages/cookies-terms';
        default:
          return 'https://vcv.ai/pages/cookies-terms';
      }
    },

    terms_link() {
      return 'https://vcv.ai/pages/terms-of-service';
    },

    current_domain() {
      if (this.lang === 'ru') {
        return 'ru';
      } else {
        return 'ai';
      }
    }
  },

  mounted() {
    this.fetchPublicCompanyAgreementsList(this.token);
  },

  methods: {
    async fetchPublicCompanyAgreementsList(token) {
      const params = {
        with: ['names', 'names.language', 'file'],
        limit: 999
      };

      return await axios
        .get(`/v3/public/vacancy/${token}/company-agreements`, { params })
        .then(res => {
          this.companyAgreementPublicList = res.data._embedded.agreements;
        })
        .catch(err => {
          return Promise.reject(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.agreement {
  margin-top: 20px;

  span {
    color: #9faab6;
  }

  ::v-deep a {
    color: #9faab6;
    text-decoration: underline;

    &:hover {
      color: $green;
    }
  }
}
</style>
